/*
 *
 *
 * (c) 2018/6/23 lihaozhou
 * Email: lihaozhou@wps.cn
 * License: KSO
 */
import config from './../config';

function log() {
  if (config.isDebug) {
    console.log(...arguments);
  }
}

function warn() {
  if (config.isDebug) {
    console.warn(...arguments);
  }
}

export default {
  log,
  warn
};
